import {formatCurrency} from '@utilities/helpers.ts'

export const formatPaymentAmount = ({
    amount,
    amountUsd,
    currency,
    prefix = ''
}: {
    amount?: number | null
    amountUsd: number
    currency?: string | null
    prefix?: string
}) => {
    const isCurrencyUSD = !currency || currency == 'USD'
    return `${prefix}${formatCurrency(amount || amountUsd, currency ?? 'USD')}${
        isCurrencyUSD ? '' : ` (${formatCurrency(amountUsd, 'USD')})`
    }`
}
